import { useState, React } from "react";
import { Grid, Column, Button, Loading, TextInput, Stack, InlineNotification, Theme } from '@carbon/react';
import {useForm} from "react-hook-form";
import {yupResolver} from '@hookform/resolvers/yup';
import * as yup from "yup";


const schema_codVerificacion = yup.object().shape({
  txtCodigo: yup.string().required("Este campo es requerido.")
                 .matches(/(?=.*?\d)^\$?(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?$/,
                  "El código es un campo numérico.")
})

const CodigoVerificacion = () => {

  const {register, handleSubmit, formState:{ errors }} = useForm({
    resolver: yupResolver(schema_codVerificacion)
  });

  const [loading, setLoading] = useState(false);
  const [codigo, setCodigo] = useState('');
  const [msgValidaCod, setMsgValidaCod] = useState([]);

  const cerrar = () => {
    setMsgValidaCod({ "showMsg": 0 });
  }

  const submitForm = (codVerifiForm) => {
    setLoading(true);

    let headers = new Headers(); headers.append('Content-Type', 'application/json');
    const datos = {};
    datos.Codigo = codVerifiForm.txtCodigo;
    
    fetch(process.env.REACT_APP_URL_SERVICE_VALIDA_CONFIRMACION, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(datos)
    }).then((res) => res.json()).then((data) => {

      if (data.Estatus == 0) {
        setMsgValidaCod({ "showMsg": 1, "kind": "success", "mensaje": data.Mensaje })
        setTimeout(function () {
          window.location.href = "/#/";
          setLoading(false);
        }, 4000);

      } else {
        setMsgValidaCod({ "showMsg": 1, "kind": "error", "mensaje": data.Mensaje });
        setLoading(false);
      }
    });
  }

  return <>

    <Theme theme="g100">
      <Loading className={'some-class'} active={loading} withOverlay={true} />
      <Grid className="codVer-container">
        <Column lg={8} md={8} sm={4}>
          <h1>Código de verificación</h1>
          <br />
          <form style={{ maxWidth: '500px' }} onSubmit={handleSubmit(submitForm)} >
            <Stack gap={5}>
              <TextInput id="txtCodigo"
                         type="text" 
                         maxLength="10"
                         labelText="Ingresar código" 
                         placeholder="Ingresa el código de verificación" 
                         /* value={codigo} onChange={(e) => setCodigo(e.target.value)} */
                         {...register("txtCodigo")}
                         invalid={errors.txtCodigo} 
                         invalidText={errors.txtCodigo?.message}
              />
              <Button type="submit">Enviar</Button>
            </Stack>
          </form>
          <br />
          {(msgValidaCod.showMsg === 1) && 
              <InlineNotification kind={msgValidaCod.kind} 
              title={msgValidaCod.mensaje}
              lowContrast={true}
              onClick={cerrar} />
          }

        </Column>
      </Grid>
    </Theme>
  </>
};

export default CodigoVerificacion;